import { Subject } from 'rxjs';

const subject = new Subject();

export const NotificationService = {
    updateNotifications: () => subject.next({ update: true }),
    getSubject: () => subject.asObservable()
};
